import { useEffect } from 'react';
import { useAuthStore } from '@/store/auth.store';
import { getSocket, disconnectSocket } from '@/lib/socket';

export function useSocket() {
  const usuario = useAuthStore(s => s.usuario);

  useEffect(() => {
    if (!usuario) return;
    const socket = getSocket();

    return () => {
      // Solo desconectar cuando el usuario hace logout (usuario pasa a null)
    };
  }, [usuario]);
}

export { getSocket, disconnectSocket };
